import { render } from "./AvatarCropper.vue?vue&type=template&id=22733d86&scoped=true"
import script from "./AvatarCropper.vue?vue&type=script&lang=js"
export * from "./AvatarCropper.vue?vue&type=script&lang=js"

import "./AvatarCropper.vue?vue&type=style&index=0&id=22733d86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22733d86"]])

export default __exports__